export default v => `${v}`.replace(/[^\d]/g, "");